export default __webpack_public_path__ + "static/Group 630-7d06c486f654f2a64187bf5fe5bf7723.png";